import Cookies from 'universal-cookie';
import { getDefaultConfig } from './Store';

const cookie = new Cookies();

export const setFeatureFlag = (key, enabled) => {
  cookie.set(key, enabled, { path: '/' });
};

export const getFeatureFlag = (key) => {
  const { appEnv } = getDefaultConfig();
  return appEnv !== 'prod' && cookie.get(key) == 'true';
};
